export default "__VITE_ASSET__067bb200__"